/**
 * Session Storage Key names used in local and session storage
 */

export enum SessionStorageKeys {
  CERTIFICATES = '_dlp.certificates',
  FULL_SEARCH_RESULTS = 'searchresults',
  FILTERED_SEARCH_RESULTS = 'filteredsearchresults',
  MAINTENANCE = 'maintenance',
  RECOMMENDED_FILTERED_SEARCH_RESULTS = 'recommendedfilteredsearchresults',
  REQUEST_VOUCHER = 'requestVoucher', // Same thing as Request a Quote for Certificate Exams
  ACCORDION = 'accordion-',
}
